<template>
  <div class="card" :class="transaction.type">
    <div class="head">
      <div class="head-right">
        <div class="icon plus">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
        </div>
        <div class="icon minus">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
        </div>
        <div class="transaction-title">
          <span class="text">شماره تراکنش</span>
          <span class="number">#{{transaction.transaction_id}}</span>
        </div>
      </div>
      <div class="head-left">
        <div class="transaction-status" :class="transaction.status" v-html="transaction.status_label"></div>
        <div class="date">{{transaction.date_jalali}}</div>
      </div>
    </div>
    <div class="body">
      <div class="transaction-about">
        <div class="description" v-html="transaction.description"></div>
        <div class="order_id" v-if="transaction.order_id">
          شماره سفارش:
          <span>#{{transaction.order_id}}</span>
        </div>
        <div class="product" v-if="transaction.product_name">
          آیتم فروخته شده:
          <span>{{transaction.product_name}}</span>
        </div>
      </div>
      <div class="transaction-amount" v-html="transaction.amount_html"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "transaction-item",
  props: ['transaction']
}
</script>

<style scoped>

</style>
